import { components, GroupBase, OptionProps } from 'react-select';
import { classes } from './Multiselect';
import Checkbox from '../Checkbox';
import { ReactElement } from 'react';

/* Screen reader issues:
- Says that Tab selects option and closes the menu, regardless of tabSelectsValue={false} or closeMenuOnSelect={false}
- Doesn't read if an option is selected or not when going through options (unless you just selected)
- Doesn't tell what (or even how many values) values are already selected when you
    first tab into the field, you have to press left arrow to read them
*/
interface CustomOptionProps<Option, IsMulti extends boolean, Group extends GroupBase<Option>>
  extends OptionProps<Option, IsMulti, Group> {
  /** despite not being in OptionProps, value is indeed being passed through.
   *
   * It is already normalized with the getOptionValue function.
   */
  value?: string;
}
const CustomOption = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: CustomOptionProps<Option, IsMulti, Group>
): ReactElement => {
  const {
    data,
    innerProps: { id, ref, ...passthroughProps },
    isDisabled,
    isMulti,
    isSelected,
    selectProps,
    value,
    children,
  } = props;
  const innerPropsWithAria = {
    id,
    ref,
    ...passthroughProps,
    role: 'option',
    'aria-selected': isSelected,
    'aria-label': selectProps.getOptionLabel(data),
  };
  return (
    <components.Option {...props} innerProps={innerPropsWithAria}>
      {isMulti ? (
        <Checkbox
          id={id as string}
          {...classes({
            element: 'option-checkbox',
          })}
          checked={isSelected}
          description={selectProps.getOptionLabel(data)}
          disabled={isDisabled}
          readOnly
          valueAttribute={value}
          {...passthroughProps}
        />
      ) : (
        children
      )}
    </components.Option>
  );
};

export default CustomOption;
